import StartNode from './startNode';
import EndNode from './endNode';
import ConversationNode from './conversationNode';
import CustomCallTransferNode from './callTransferNode';
import CustomConnectorNode from './connectorNode';
import CallConnectNode from './callConnectNode';
import AppointmentNode from './appointmentNode';
import ChatTransferNode from './chatTransferNode';
import ExtractVariableNode from './extractVariableNode';
import ApiNode from './ApiNode';
import KnowledgeNode from './knowledgeNode';
import ConditionNode from './conditionNode';

export const initialNodes = [
  {
    id: '1',
    type: 'begin',
    position: {
      x: 0,
      y: 43
    },
    targetPosition: 'left',
    sourcePosition: 'right',
    measured: {
      width: 72,
      height: 27
    },
    selected: false,
    dragging: false
  }
];

export const nodeTypes = {
  // connector: CustomConnectorNode,
  conversation: ConversationNode,
  // callTransfer: CustomCallTransferNode,
  begin: StartNode,
  end: EndNode,
  call_connect: CallConnectNode,
  appointment: AppointmentNode,
  chat_transfer: ChatTransferNode,
  variable: ExtractVariableNode,
  api: ApiNode,
  knowledge: KnowledgeNode,
  condition: ConditionNode
};
